import React from "react";

export default function UserScoreBySurvey({ user }) {

    const dummy = [
        { title: "Workplace Utilisation", user: 68, org: 74 },
        { title: "Moves & Strategy", user: 71, org: 72 },
        { title: "Consultancy Feedback", user: 65, org: 70 }
    ];

    return (
        <div style={{ padding: "10px" }}>
            {dummy.map(function (row, index) {
                return (
                    <div key={index} style={{ marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", marginBottom: "4px" }}>{row.title}</div>
                        <div style={{ position: "relative", height: "10px", background: "#eee", borderRadius: "6px" }}>
                            <div
                                style={{
                                    position: "absolute",
                                    height: "100%",
                                    width: row.org + "%",
                                    background: "#ccc",
                                    borderRadius: "6px"
                                }}
                            />
                            <div
                                style={{
                                    position: "absolute",
                                    height: "100%",
                                    width: row.user + "%",
                                    background: "#4c9aff",
                                    borderRadius: "6px"
                                }}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
